import { trackApparelDiscoveryShowroomV2View } from "@faire/web-api--source/events/apparelDiscovery/view/showroomV2";
import { IBadge } from "@faire/web-api--source/indigofair/badges/IBadge";
export var handleShowroomProductBadgeViewed = function(productToken) {
    var requestId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", badgeViewed = arguments.length > 2 ? arguments[2] : void 0;
    if ((badgeViewed === null || badgeViewed === void 0 ? void 0 : badgeViewed.type) === IBadge.BadgeType.SHOWROOM) {
        trackApparelDiscoveryShowroomV2View("product-tile", productToken, requestId);
    }
};
